const moment = require('moment');

import {t, nt, dt} from 'l10n';

import {hasAvatar} from 'bobtvuser'

import {GENDER_TEXT} from 'constants/genders'

export function getAgeText(user) {
    return nt('%1 year', '%1 years', user.age)
}

export function getGenderText(user) {
    return dt('gender_select', GENDER_TEXT[user.gender] || '')
}

export function getStatusText(user) {
    return user.online ? t('online') : t('offline');
}

export function filterRoomUser(user, room) {
    return !user.paused && user.snapshot;
}

export function getRoomUserWeight(user) {
    let weight = 0;

    let snapshot = !!user.snapshot;
    if (snapshot) weight += 10000;

    /*
    let avatar = hasAvatar(user);
    if (avatar) weight += 10000;
    */

    let genderWeights = {
        1: 1100,
        2: 2000, // females on top
        3: 1500,
        4: 1000,
    };
    weight += (genderWeights[user.gender] || 0);

    weight += (user.gift_points || 0);

    weight += ((user.watcher_count || 0) * 1000);

    // the higher weighted user will be closer to sorted list's start

    return weight;
}


export function formatExpirationDate(user, long = true) {
    if (!user || !user.expiration_date_ts) return null;

    let format = t('MM/DD/YYYY');

    if (long) {
        format = t('MM/DD/YYYY [at] HH:mm');
    }

    return moment.unix(user.expiration_date_ts).format(format)
}

export function formatLastOnlineDate(user) {
    return moment(user.last_online).format(t('MM/DD/YYYY'))
}

/**
 * @param user {{country: string, region: string, [country_displayed]: string, [region_displayed]: string}}
 * @param isCurrentUser Boolean
 */
export function formatLocation(user, isCurrentUser = false) {
    let cField = isCurrentUser ? 'country_displayed' : 'country',
        rField = isCurrentUser ? 'region_displayed' : 'region';

    return user[cField] ? user[cField] + (user[rField] ? (', ' + user[rField]) : '') : '';
}



// WEBPACK FOOTER //
// ./src/utils/user.js